import { useState, useEffect } from 'react';
// import axios from 'axios';
import { DropzoneArea } from 'react-mui-dropzone';
import { getImage } from 'src/services/images.services';
import { styled } from '@mui/material';
import PulseLoader from '../loaders/PulseLoader';

const StyledDropzoneArea = styled(`div`)(({ theme }) => ({
  '& .MuiDropzoneArea-textContainer': {
    display: `flex`,
    flexDirection: `column-reverse`,
    alignItems: `center`
  },
  '& .MuiDropzoneArea-icon': {
    width: 50,
    height: 50,
    color: `#5F5777`
  },
  '& .MuiDropzonePreviewList-root': {
    width: `100%`,
    minHeight: 'fit-content',
    margin: 0
  },

  '& .MuiDropzonePreviewList-removeButton': {
    backgroundColor: `transparent`,
    boxShadow: `none`,
    color: theme.palette.error.main,
    opacity: 1,
    top: -0,
    right: 0,
    '&:hover': {
      backgroundColor: `transparent`,
      color: theme.palette.text.primary
    }
  },
  '& .MuiDropzonePreviewList-imageContainer': {
    padding: '1%'
  },
  '& .MuiDropzoneArea-root': {
    backgroundColor: `#f0f0f0`,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    minHeight: 'fit-content',
    border: 'none',
    borderRadius: 10,
    alignItems: 'center'
  }
}));
const Dropzone = ({
  addedFiles = [],
  setAddedFiles,
  oldFiles = [],
  deletedImages = [],
  setDeletedImages
}) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [oldImages, setOldImages] = useState({});
  useEffect(async () => {
    if (oldFiles) {
      setLoading(true);
      const newImages = [];
      const newOldImages = {};
      Promise.all(
        oldFiles.map(async (image) => {
          const dataUrl = await getImage(image);
          const key = dataUrl?.match(/[^/]+$/)[0];
          newOldImages[key] = image;
          newImages.push(dataUrl);
        })
      ).then(() => {
        setOldImages(newOldImages);
        setImages(newImages);
        setLoading(false);
      });
    }
  }, []);
  if (loading) return <PulseLoader />;
  return (
    <StyledDropzoneArea>
      <DropzoneArea
        maxFileSize={10000000}
        onDrop={(files) => {
          setAddedFiles([...addedFiles, ...files]);
        }}
        filesLimit={10}
        getPreviewIcon={(file) => <img src={file.data} style={{ marginTop: '1%' }} />}
        initialFiles={images ?? []}
        acceptedFiles={['image/*']}
        onDelete={(file) => {
          if (oldImages[file.name]) {
            setDeletedImages([...deletedImages, oldImages[file.name]]);
          }
          if (addedFiles.includes(file)) {
            setAddedFiles(addedFiles.filter((f) => f !== file));
          }
        }}
      />
    </StyledDropzoneArea>
  );
};
export default Dropzone;
